import React from 'react';
import { connect } from 'react-redux';
import { findMatch } from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import { changeCohortVisualisationXAxis } from '../actions';
import CohortAxisDropdown from '../components/CohortAxisDropdown';
import { cohortAxis } from '../constants';
import {
  filterableFields,
  getCohortActiveDictionary,
} from '../../helper';
import {
  chartReadStatus,
  filterValidChartQueries,
  filterXAxisFields,
} from '../helper';
import { findActiveQuery } from '../../state/shared';

const CohortAxisContainer = ({
  cohort,
  category,
  code,
  changeAxis,
  fields,
  value,
  chartType,
}) => {
  const { readStatus } = chartReadStatus(filterValidChartQueries(cohort, chartType));

  return (
    <CohortAxisDropdown
      axis={cohortAxis.X_AXIS}
      value={value}
      fields={filterXAxisFields(fields)}
      onChange={(name, label) => changeAxis(category, code, chartType, name, label)}
      disabled={readStatus === states.PENDING}
    />
  );
};

const mapStateToProps = ({
  cohorts: {
    cohorts,
  },
}, ownProps) => {
  const { cohort, query } = findActiveQuery(cohorts, ownProps);
  const chartQuery = findMatch(query.visualisations, ownProps.chartType);
  const dictionary = getCohortActiveDictionary(cohort) || { fields: [] };

  return ({
    cohort,
    fields: filterableFields(dictionary.fields),
    value: chartQuery.xAxis.value,
  });
};

const mapDispatchToProps = {
  changeAxis: changeCohortVisualisationXAxis,
};

export default connect(mapStateToProps, mapDispatchToProps)(CohortAxisContainer);
